<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
        xl="3"
        align-self="center"
      >
        <v-card>
          <v-container>
            <v-card-text
                class="font-weight-bold title"
              >로그인</v-card-text>
              <v-divider></v-divider>

            <v-list
              flat
            >
              <v-list-item
                v-for="(item, index) in items"
                :key="item.id"
                :style="{ 'backgroundColor': item.backgroundColor }"
                class="tile"
                @click="login(item.id, index)"
              >
                <v-list-item-avatar
                  image
                  tile
                >
                  <v-img
                    contain
                    :src="item.icon"
                    :alt="item.name + ' 아이디로 로그인 버튼 이미지'"
                    width="30px"
                    height="30px"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title :class="item.fontClass">{{ item.name }} 로그인</v-list-item-title>
                </v-list-item-content>
                <div v-if="lastLoginService === item.id" class="lastLoginService">최근 로그인</div>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { api } from "../mixins/api.js"

const LAST_LOGIN_SERVICE = "lastLoginService";

export default {
  data() {
    return {
      items: [
        {
          id: 'naver',
          name: '네이버',
          icon: require('../assets/naver_logo.png'),
          backgroundColor: '#1ec800',
          fontClass : 'black--text text-center'
        },
        {
          id: 'kakao',
          name: '카카오',
          icon: require('../assets/kakao_logo.png'),
          backgroundColor: '#f7e317',
          fontClass : 'black--text text-center'
        },
        {
          id: 'google',
          name: '구글',
          icon: require('../assets/google_logo.png'),
          backgroundColor: '#ffffff',
          fontClass : 'black--text text-center'
        },
        // {
        //   id: 'facebook',
        //   name: '페이스북',
        //   icon: require('../assets/facebook_logo.png'),
        //   backgroundColor: '#4267b2',
        //   fontClass : 'white--text text-center'
        // }
      ],
      lastLoginService: null
    }
  },
  created() {
    this.lastLoginService = localStorage.getItem(LAST_LOGIN_SERVICE);
  },
  methods: {
    async login(providerName, index) {
      this.$ga.event('로그인', '클릭', 'OAuth', index);

      const redirectUrl = await api.methods.loginApi(providerName);
      if (redirectUrl === null) {
          this.$router.push('/');
      } else {
          // 어떤 로그인을 시도 했는지, 저장한다.
          localStorage.setItem(LAST_LOGIN_SERVICE, providerName)
          window.location = redirectUrl;
      }
    }
  }
}
</script>

<style scoped>
.tile {
  margin: 5px;
  transition-duration: 0.5s;
  border: 0.1px solid #BDBDBD;

}
.tile:hover {
  opacity: 0.8;
}
.naver {
  background-color: #1ec800;
}
.kakao {
  background-color: #f7e317;
}
.google {
  background-color: #ffffff;
}
.facebook {
  background-color: #4267b2;
}

.lastLoginService {
  color: #F0F0F0;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: #F24E1E;
  position: absolute;
  right: 12px;
}
</style>
